module.exports = __webpack_public_path__ + "static/card-cinema-4663b7222f3db524e24e70263df1f9ce.png";